const configuredAdminEmails = () =>
    (process.env.REACT_APP_ADMIN_EMAILS || '')
        .split(',')
        .map((email) => email.trim().toLowerCase())
        .filter(Boolean);

export const isAdminUser = (user) => {
    const email = String(user?.email || '').trim().toLowerCase();
    return Boolean(email && configuredAdminEmails().includes(email));
};
